import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonCol, IonRow } from '@ionic/angular/standalone';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { DeliveryManifestComponent } from './delivery-manifest/delivery-manifest.component';
import { DriverLoadReportComponent } from './driver-load-report/driver-load-report.component';
import { DryIceReportComponent } from './dry-ice-report/dry-ice-report.component';
import { LoadDiscrepenancyReportComponent } from './load-discepenancy-report/load-discepenancy-report.component';
import { PickupManifestComponent } from './pickup-manifest/pickup-manifest.component';
import { SendAgainComponent } from './send-again/send-again.component';

@NgModule({
  declarations: [
    DriverLoadReportComponent,
    LoadDiscrepenancyReportComponent,
    DeliveryManifestComponent,
    PickupManifestComponent,
    DryIceReportComponent,
    SendAgainComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
    IonRow,
    IonCol,
  ],
})
export class OnRoadOperationModule {}
